import "../../css/home1.css";
import voilaLogo from "../../img/voilaLogoLetrasPurple.png";
import Orb from "./effects/Orb";
import AnimatedContent from "./effects/AnimatedContent";
import { useNavigate } from 'react-router-dom';

function HomeSection1() {

  const navigate = useNavigate();
  const handleConsultationClick = () => {
    navigate('/contact');
  };


  return (
    <section className="section1" id="section1">
      <Orb
        baseSize={0.6}
        baseInnerRadius={0.7}
        hue={1}
        baseHoverIntensity={0.25}
        baseGlowIntensity={1.3}
        responsive={true}
      >
        <div className="container orb-container">
          <div className="row">
            <div className="col-lg-12 d-flex justify-content-center">
              <img
                src={voilaLogo}
                alt="Voilá Consultoría Logo"
                className="img-fluid orb-logo"
              />


            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 d-flex justify-content-center">
              <AnimatedContent
                distance={150}
                direction="vertical"
                reverse={false}
                config={{ tension: 60, friction: 40 }}
                initialOpacity={0}
                animateOpacity
                scale={1.1}
                threshold={0.2}
              >
                <div className="text-center">
                  <h3 className="international-message">Impulsamos tu negocio hacia el mercado internacional</h3>
                </div>
                <div className="text-center">
                  <button className="btn btn2 orb-button" onClick={() => handleConsultationClick()}>
                    Solicita tu primera<br></br>consultoría gratuita
                  </button>
                </div>
              </AnimatedContent>


            </div>
          </div>
        </div>
      </Orb>
    </section>
  );
}

export default HomeSection1;